import { refuseHolidayRequest } from "../../api/events";
import { showToastError, showToastSuccess } from "../../services/toast";
import { useTimeStore } from "../../stores/time";
import { ActionButton } from "../ui/page/PageShell";

const RefuseHolidays = () => {
  // Store
  const {
    idTimesSelected,
    setIdTimesSelected,
    update,
    setUpdate,
  } = useTimeStore();

  const handleRefuseHolidays = () => {
    refuseHolidayRequest(idTimesSelected)
      .then(() => {
        showToastSuccess("Les demandes de congés ont été refusées avec succès");
        setIdTimesSelected([]);
        setUpdate(!update);
      })
      .catch(() => {
        showToastError("Erreur lors du refus des demandes de congés");
      });
  }
  return (
    <ActionButton variant="danger" onClick={() => handleRefuseHolidays()}>
      Refuser
    </ActionButton>
  )
}

export default RefuseHolidays
